export default __webpack_public_path__ + "static/media/fire-solid.73b47147.svg";